import { render, staticRenderFns } from "./tenantCompanies.vue?vue&type=template&id=e3151342&scoped=true"
import script from "./tenantCompanies.vue?vue&type=script&lang=js"
export * from "./tenantCompanies.vue?vue&type=script&lang=js"
import style0 from "./tenantCompanies.vue?vue&type=style&index=0&id=e3151342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3151342",
  null
  
)

export default component.exports